<template>
  <div class="examineBox" style="margin-top:10px">
    <div class="containter" v-loading='loading'>
      <div class="topOperation">
        <span class="title">{{$route.path == '/redInvoicesExamine'?'红字发票审核':'红字发票开票申请'}}</span>
        <div style="display:flex;align-items:center">
          <!-- <span style="font-size:14px;margin-left:10px">作废状态：</span>
          <el-select style="width:160px" @change="init(1)" v-model="voided_status" size='mini' :clearable='true' filterable placeholder="请选择作废状态">
            <el-option v-for="(item,index) in voidedList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
          <template v-if="$route.path == '/redInvoicesList'">
            <a class="fileTemplate" href='https://order-consumption-system.oss-cn-beijing.aliyuncs.com/templates/%E7%BA%A2%E5%AD%97%E5%8F%91%E7%A5%A8%E7%94%B3%E8%AF%B7%E6%A8%A1%E6%9D%BF2022.xlsx'>红字发票导入模板</a>
            <el-upload style="display: inline-block;float: left;" ref="upload" :action="URL.BASEURL + URL.redApplyImport" :on-success="uploadSuccess" :on-error="uploadError" :on-progress='uploadProgress' :data="{
                    admin_id: JSON.parse(this.$cookie.getCookie('userInfo')).admin_id,
                    ttl: JSON.parse(this.$cookie.getCookie('userInfo')).ttl,
                    sign: JSON.parse(this.$cookie.getCookie('userInfo')).sign,
                }" :show-file-list='false' :auto-upload="true" accept=".xlsx,.csv">
              <div class="batchDelete">红字发票申请</div>
            </el-upload>
          </template>
          <label style="font-size:13px">财务审核时间：</label>
          <el-date-picker @change="init(1)" style="width:240px" v-model="approved_date" type="daterange" value-format="yyyy-MM-dd" size='mini' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
      <div style="margin: 0 16px 16px;">
        <el-select v-model="status" @change="init(1)" size="mini" clearable placeholder="开票状态">
          <el-option v-for="(item,index) in userInfo.role_id==10?statusListCW:statusList" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="company" @change="init(1)" style="width:150px;" size="mini" clearable placeholder="签约公司">
          <el-option v-for="(item,index) in companyList" :key="index" :label="item.company" :value="item.company">
          </el-option>
        </el-select>
        <el-date-picker @change="init(1)" style="width:160px" v-model="cdate" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="申请日期">
        </el-date-picker>

        <el-input placeholder="请输入客户全称" v-model.trim="customer_name" clearable @keydown.enter.native="init(1)" @clear="init(1)" size="mini" style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="init(1)" style="padding:0 10px"></el-button>
        </el-input>

        <el-input placeholder="发票序列号" v-model.trim="serial_number" clearable @keydown.enter.native="init(1)" @clear="init(1)" size="mini" style="width:160px">
          <el-button slot="append" icon="el-icon-search" @click="init(1)" style="padding:0 10px"></el-button>
        </el-input>

        <!-- <el-input placeholder="请输入结算单序列号" v-model.trim="statements_id" clearable @keydown.enter.native="statements_id?init(1):''" @clear="init(1)" size="mini" style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="statements_id?init(1):''" style="padding:0 10px"></el-button>
        </el-input> -->
        <div class="refreshIcon batchDelete" @click="init(page)">
          刷新
          <i class="el-icon-refresh"></i>
        </div>
      </div>
      <div class="listBox">
        <el-table class="table" :header-cell-style="{background:'#f5f7fa'}" :data="accountList" height="calc(100vh - 252px)" border>
          <el-table-column prop="id" label="序列号" align='center' width="70"></el-table-column>
          <el-table-column prop="customer_name" label="客户名称" align='center' width="100"></el-table-column>
          <el-table-column prop="invoice_amount" align='center' label="开票金额"></el-table-column>
          <el-table-column prop="applicant_time" align='center' label="申请日期"></el-table-column>
          <el-table-column prop="handler" align='center' label="申请人"></el-table-column>
          <el-table-column prop="company" align='center' label="签约公司"></el-table-column>
          <!-- <el-table-column prop="invoiced_time" align='center' label="开票日期"></el-table-column>
          <el-table-column align='center' label="是否作废" width="70">
            <template slot-scope="scope">
              <img v-if="scope.row.is_voided==1" src="@/assets/img/voided.png" style="width:40px;height:29px;margin:auto" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="voided_inv_id" align='center' label="作废发票序列号"></el-table-column>
          <el-table-column align='center' label="作废状态">
            <template slot-scope="scope">
              <span v-if="scope.row.voided_status == 1" style="color:#EF7400">待商务审核</span>
              <span v-if="scope.row.voided_status == 2" style="color:#EF7400">待财务审核</span>
              <span v-if="scope.row.voided_status == 3" style="color:#EF7400">商务审核驳回</span>
              <span v-if="scope.row.voided_status == 4" style="color:#00BB5D">财务审核通过</span>
              <span v-if="scope.row.voided_status == 5" style="color:#d51313">财务审核驳回</span>
            </template>
          </el-table-column> -->
          <el-table-column align='center' label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" style="color:#EF7400">待商务审核</span>
              <span v-if="scope.row.status == 2" style="color:#EF7400">待财务审核</span>
              <span v-if="scope.row.status == 3" style="color:#EF7400">商务审核驳回</span>
              <span v-if="scope.row.status == 4" style="color:#00BB5D">财务审核通过</span>
              <span v-if="scope.row.status == 5" style="color:#d51313">财务审核驳回</span>
              <!-- <span v-if="scope.row.status == 6" style="color:#fc726d">财务发票撤销</span> -->
              <p v-if="scope.row.new_inv_id" style="color: #7b7676;">{{`已重提，重提序列号：${scope.row.new_inv_id}`}}</p>
            </template>
          </el-table-column>
          <el-table-column align='center' label="操作">
            <template slot-scope="scope">
              <button class="detailButton" @click="goDetail(scope.row)">申请详情</button>
              <!-- 我的发票申请页面撤回按钮 -->
              <!-- <button class="detailButton" style="background:#fc726d" v-if="($route.path=='/myInvoiceApply')&&(scope.row.status == 1 || scope.row.status == 2)" @click="invoiceWithdraw(scope.row)">发票撤回</button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationBox">
          <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 撤销 -->
    <!-- <el-dialog title="撤销发票" :visible.sync="invoiceFlag" width="30%" :close-on-click-modal='false' center>
      <div class="dialogBox" v-loading='invoiceLoading'>
        <div class="dialogitem">
          <label>撤销理由：</label>
          <el-input style="margin-top:10px;width:100%" type="textarea" :rows="2" placeholder="请输入撤销理由" v-model="verify_note">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="invoiceFlag=false;verify_note='';invoice_id=''" size="mini">取消</el-button>
        <el-button type="primary" @click="invoiceCancel()" size="mini">发票撤销</el-button>
      </span>
    </el-dialog> -->
    <el-dialog title="开票信息填写" :visible.sync="invoiceFillingFlag" width="60%" top="10vh" :close-on-click-modal='false'>
      <invoice-filling v-if="invoiceFillingFlag" :filename='filename' @updateList="invoiceFillingFlag=false;init(1)" @closeToast='invoiceFillingFlag=false;'></invoice-filling>
    </el-dialog>
  </div>
</template>
<script>
import invoiceFilling from './InvoiceFilling.vue'
export default {
  components: { invoiceFilling },
  data () {
    return {
      serial_number: '',
      page: 1,
      page_size: 20,
      total: 0,
      loading: false,
      tab: 0,
      accountList: [],
      status: '',
      statusList: [
        { value: 1, label: '待商务审核' },
        { value: 2, label: '待财务审核' },
        { value: 3, label: '商务审核驳回' },
        { value: 4, label: '财务审核通过' },
        { value: 5, label: '财务审核驳回' },
        { value: 6, label: '财务发票撤销' },
      ],
      statusListCW: [
        { value: 2, label: '待财务审核' },
        { value: 4, label: '财务审核通过' },
        { value: 5, label: '财务审核驳回' },
        { value: 6, label: '财务发票撤销' },
      ],
      // voidedList: [
      //   { value: 1, label: '待商务审核' },
      //   { value: 2, label: '待财务审核' },
      //   { value: 3, label: '商务审核驳回' },
      //   { value: 4, label: '财务审核通过' },
      //   { value: 5, label: '财务审核驳回' },
      //   { value: 6, label: '财务发票撤销' },
      // ],
      cdate: '',
      customer_name: '',
      invoice_id: '',
      userInfo: {},
      // voided_status: '',
      approved_date: [],
      invoiceFlag: false,
      invoiceLoading: false,
      verify_note: '',
      companyList: [],
      company: '',
      statements_id: '',
      invoiceFillingFlag: false,
      filename: ''
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    this.getCompany()
    this.init(1)
  },
  mounted () {
  },
  methods: {
    // invoiceWithdraw (row) {//发票撤回
    //   this.$confirm('确定要撤销此次申请', '提示', {
    //     distinguishCancelAndClose: true,
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.$loading(this.$loadingConfig);
    //     this.$axios.post(this.URL.BASEURL + this.URL.invoiceWithdraw, {
    //       id: row.id
    //     }).then((res) => {
    //       this.$loading(this.$loadingConfig).close();
    //       var res = res.data;
    //       if (res && res.errno == 0) {
    //         this.init(this.page)
    //       } else {
    //         this.$message({
    //           message: res.err,
    //           type: 'warning'
    //         })
    //       }
    //     }).catch(() => {
    //       this.$loading(this.$loadingConfig).close();
    //     })
    //   }).catch((action) => {
    //   });
    // },
    // invoiceCancel () {//财务发票撤销
    //   if (this.verify_note == '' || !this.verify_note) {
    //     this.$message({
    //       message: '请输入撤销理由',
    //       type: 'warning'
    //     })
    //     return
    //   }
    //   this.invoiceLoading = true;
    //   this.$axios.post(this.URL.BASEURL + this.URL.invoiceCancel, {
    //     id: this.invoice_id,
    //     verify_note: this.verify_note
    //   }).then((res) => {
    //     this.invoiceLoading = false;
    //     var res = res.data;
    //     if (res && res.errno == 0) {
    //       this.invoice_id = ''
    //       this.verify_note = ''
    //       this.invoiceFlag = false
    //       this.init(this.page)
    //     } else {
    //       this.$message({
    //         message: res.err,
    //         type: 'warning'
    //       })
    //     }
    //   }).catch(() => {
    //     this.invoiceLoading = false;
    //   })
    // },
    goDetail (data) {
      this.invoice_id = data.id;
      if (this.$route.path == '/redInvoicesExamine') {
        let routeData = this.$router.resolve({
          path: '/redInvoicesExamineDetail/' + this.invoice_id,
        })
        this.$winopen(routeData.href)
      } else {
        let routeData = this.$router.resolve({
          path: '/redInvoicesDetail/' + this.invoice_id,
        })
        this.$winopen(routeData.href)
      }
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    init (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.redInvoicesList, {
        params: {
          id: this.serial_number,
          page: page,
          page_size: this.page_size,
          customer_name: this.customer_name,
          status: this.status,
          cdate: this.cdate,
          // voided_status: this.voided_status,
          approved_start_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[0] : '',
          approved_end_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[1] : '',
          company: this.company,
          // statements_id: this.statements_id
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    uploadSuccess (res, file, fileList) {
      let _this = this;
      this.$loading(this.$loadingConfig).close()
      if (res.errno == 0) {
        // 导入成功
        this.filename = res.rst.filename
        this.invoiceFillingFlag = true
      } else {
        var errHint = '';
        if (Array.isArray(res.rst.error)) {
          errHint = '<p>有误字段：</p><ul>'
          res.rst.error.forEach((item) => {
            errHint += `<li>第${item.row}行：${item.error.join(',')}</li>`
          })
          errHint += '</ul>'
        } else {
          errHint = res.rst.error
        }
        this.$alert(errHint, res.err, {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          callback: action => {
          }
        });
      }
    },
    uploadError (err, file, fileList) {
      this.$loading(this.$loadingConfig).close()
      this.$alert('上传失败', '服务器错误', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        callback: action => {
        }
      });
    },
    uploadProgress () {//上传中
      this.$loading(this.$loadingConfig);
    },
    getCompany () {
      this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList, {
        params: {
          page: 1,
          pagesize: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.companyList = res.rst.data;
        } else {
        }
      }).catch(() => {
      })
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-date-editor .el-range-separator {
  width: 20px;
}
.examineBox {
  .containter {
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    .topOperation {
      padding: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        font-size: 15px;
        color: #202652;
        line-height: 21px;
        font-weight: 500;
        display: inline-block;
        vertical-align: middle;
      }
      .selectBox {
        display: inline-block;
        vertical-align: middle;
        .selectItem {
          float: left;
          font-size: 13px;
          margin-left: 20px;
          cursor: pointer;
          .icon {
            width: 13px;
            height: 13px;
            border-radius: 3px;
            border: 1px solid #d2d2d2;
            display: inline-block;
            vertical-align: bottom;
            margin-right: 3px;
          }
          &.active {
            .icon {
              border-color: #2662ff;
              position: relative;
              &::before {
                content: "";
                display: inline-block;
                width: 7px;
                height: 7px;
                background: #2662ff;
                border-radius: 1px;
                position: absolute;
                top: 2px;
                left: 2px;
              }
            }
          }
        }
      }
    }
  }
  .table {
    width: calc(100% - 30px);
    margin: 0 15px;
  }
  .detailButton {
    min-width: 60px;
    height: 22px;
    background: #5b7bfe;
    border-radius: 4px;
    color: #ffffff;
    font-size: 12px;
    border: none;
    padding: 0 3px;
  }
}
.batchDelete {
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #5b7bfe;
  background: #5b7bfe;
  color: #fff;
  margin-right: 16px;
  cursor: pointer;
  padding: 0 4px;
  float: right;
}
.refreshIcon {
  margin-right: 10px;
  background: #67c23a;
  border-color: #67c23a;
}
.fileTemplate {
  font-size: 12px;
  margin: 0 10px;
  text-decoration: underline;
  color: #5b7bfe;
  display: block;
}
</style>
<style lang="scss">
.el-date-editor .el-range-separator {
  width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/redInvoices/list.vue